export default "__VITE_ASSET__B_jL1j24__"